import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TenantSubscriptionSummaryModel } from "src/app/models/tenants/tenant-subscription-summary.model";
import { TenantSubscriptionUpdateModel } from "src/app/models/tenants/tenant-subscription-update.model";
import { TenantSubscriptionModel } from "src/app/models/tenants/tenant-subscription.model";
import { Configuration } from "src/assets/Configuration";

@Injectable({
  providedIn: 'root',
})
export class TenantSubscriptionService {

  constructor(private httpClient: HttpClient) {
  }

  public isPublishedToSubscribers(): Observable<boolean> {
    return this.httpClient.get<boolean>(
      Configuration.getApiBaseUrl() + '/tenantsubscription/published'
    );
  }

  public activatePublishingMode(): Observable<void> {
    return this.httpClient.post<void>(
      Configuration.getApiBaseUrl() + '/tenantsubscription/activate-publishing-mode',
      {}
    );
  }

  public deactivatePublishingMode(): Observable<void> {
    return this.httpClient.post<void>(
      Configuration.getApiBaseUrl() + '/tenantsubscription/deactivate-publishing-mode',
      {}
    );
  }

  public getCurrentTenantSubscription(): Observable<TenantSubscriptionModel | null> {
    return this.httpClient.get<TenantSubscriptionModel | null>(
      Configuration.getApiBaseUrl() + '/tenantsubscription'
    );
  }

  public getTenantSubscription(tenantId: string): Observable<TenantSubscriptionModel> {
    return this.httpClient.get<TenantSubscriptionModel>(
      Configuration.getApiBaseUrl() + '/tenantsubscription/' + tenantId
    );
  }

  public getTenantSubscriptionSummary(
    tenantId: string
  ): Observable<TenantSubscriptionSummaryModel> {
    return this.httpClient.get<TenantSubscriptionSummaryModel>(
      Configuration.getApiBaseUrl() + '/tenantsubscription/' + tenantId + '/summary'
    );
  }
  

  public createTenantSubscription(model: TenantSubscriptionUpdateModel): Observable<TenantSubscriptionModel> {
    return this.httpClient.post<TenantSubscriptionModel>(
      Configuration.getApiBaseUrl() + '/tenantsubscription', 
      model
    );
  }

  public updateTenantSubscription(model: TenantSubscriptionUpdateModel): Observable<TenantSubscriptionModel> {
    return this.httpClient.put<TenantSubscriptionModel>(
      Configuration.getApiBaseUrl() + '/tenantsubscription', 
      model
    );
  }
}